import { useMemo } from 'react';
import { useCookies } from 'react-cookie';
import { TRACKING_COOKIES } from '../utils/Constants';
import { TrackingPayload } from '../utils/utils';

export const useGetTrackingCookies = (): TrackingPayload => {
  const [cookie] = useCookies();
  return useMemo(() => {
    let payload: TrackingPayload = {};
    TRACKING_COOKIES.forEach(cookieName => {
      payload = {
        ...payload,
        [cookieName]: cookie[cookieName],
      };
    });
    return payload;
  }, [cookie]);
};
